module.exports = __webpack_public_path__ + "static/img/code2.5313e341.png";